// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.home-banner-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 80px;
    background-color: white;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    padding-top: 100px;
  }
  
  .banner-content {
    flex: 1 1;
    max-width: 600px;
    padding-right: 40px;
  }
  
  .banner-heading {
    font-size: 36px;
    font-weight: 900;
    line-height: 48px;
    margin-bottom: 20px;
    color: #000;
    font-family: Thicker;
  }
  
  .banner-highlight {
    color: #BA1E24;
    font-weight: 800;
    font-size: 48px;
    font-family: Thicker;
  }
  
  .banner-text {
    font-size: 18px;
    line-height: 25.2px;
    margin-bottom: 30px;
    color: #000;
    /* font-family: "Montserrat" !important; */
    font-weight: 600;
  }
  
  .banner-button {
    background-color: #000;
    color: white;
    border: none;
    padding: 15px 45px;
    font-size: 18px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.3s;
  }
  
  .banner-button:hover {
    background-color: #333;
  }
  
  .banner-image {
    flex: 1 1;
    display: flex;
    justify-content: flex-end;
  }
  
  .banner-image img {
    max-width: 100%;
    height: auto;
  }
  
@media (max-width: 768px) {
  .home-banner-container {
    flex-direction: column;
    padding: 40px 20px;
  }

  .banner-content {
    padding-right: 0;
    text-align: center;
  }

  .banner-heading {
    font-size: 28px;
    line-height: 36px;
  }

  .banner-highlight {
    font-size: 36px;
  }

  .banner-text {
    font-size: 16px;
    line-height: 22px;
  }

  .banner-image {
    margin-top: 30px;
  }
}
  
`, "",{"version":3,"sources":["webpack://./src/components/newSeason/homebannerr.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,0CAA0C;IAC1C,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;AAEF;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["\n.home-banner-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 40px 80px;\n    background-color: white;\n    width: 100%;\n    max-width: 100%;\n    margin: 0 auto;\n    padding-top: 100px;\n  }\n  \n  .banner-content {\n    flex: 1;\n    max-width: 600px;\n    padding-right: 40px;\n  }\n  \n  .banner-heading {\n    font-size: 36px;\n    font-weight: 900;\n    line-height: 48px;\n    margin-bottom: 20px;\n    color: #000;\n    font-family: Thicker;\n  }\n  \n  .banner-highlight {\n    color: #BA1E24;\n    font-weight: 800;\n    font-size: 48px;\n    font-family: Thicker;\n  }\n  \n  .banner-text {\n    font-size: 18px;\n    line-height: 25.2px;\n    margin-bottom: 30px;\n    color: #000;\n    /* font-family: \"Montserrat\" !important; */\n    font-weight: 600;\n  }\n  \n  .banner-button {\n    background-color: #000;\n    color: white;\n    border: none;\n    padding: 15px 45px;\n    font-size: 18px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.3s;\n  }\n  \n  .banner-button:hover {\n    background-color: #333;\n  }\n  \n  .banner-image {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n  }\n  \n  .banner-image img {\n    max-width: 100%;\n    height: auto;\n  }\n  \n@media (max-width: 768px) {\n  .home-banner-container {\n    flex-direction: column;\n    padding: 40px 20px;\n  }\n\n  .banner-content {\n    padding-right: 0;\n    text-align: center;\n  }\n\n  .banner-heading {\n    font-size: 28px;\n    line-height: 36px;\n  }\n\n  .banner-highlight {\n    font-size: 36px;\n  }\n\n  .banner-text {\n    font-size: 16px;\n    line-height: 22px;\n  }\n\n  .banner-image {\n    margin-top: 30px;\n  }\n}\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
